import React from 'react'
import { FaRegCheckCircle } from 'react-icons/fa'
import bestForMe from 'images/content/Insurance-Plan-is-Best.jpeg'

const FourthSection = () => {
    return (
        <div className='flex flex-wrap justify-center gap-8'>
            <div className='w-full max-w-xl space-y-4'>
                <div className='text-2xl sm:text-4xl font-bold'>Which Health Insurance Plan is Best for Me?</div>
                <div className='space-y-4 sm:text-lg'>
                    <p>When choosing a plan, you first need to assess your personal healthcare needs, look at all of your options, and choose a health insurance plan that fits your lifestyle and stays within your budget. How do you determine which health insurance is primary? You can by asking these questions:</p>
                    <ul>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> How often do I visit the doctor?</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> What type of treatment do I need in the next 12 months?</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> What prescription drugs do I currently take?</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> What type of outpatient treatment will I need?</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Which healthcare providers/physicians do I prefer?</li>
                    </ul>
                    <p>Once you establish your healthcare needs, you can narrow your search to affordable family health insurance companies in your state. Some of the health insurance providers that we work with includes:</p>
                </div>
            </div>
            <div className='flex justify-end'>
                <img src={bestForMe} alt='plans' />
            </div>
        </div>
    )
}

export default FourthSection